import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'
import qs from 'qs'

export interface Config {
  language: () => string
  access_token?: () => string
}

export class ApiClients {
  private readonly ownServerBaseUrl = process.env.REACT_APP_OWN_SERVER_BASE_URL ?? process.env.NEXT_PUBLIC_OWN_SERVER_BASE_URL
  private config: Config

  exchange: AxiosInstance
  fileServer: AxiosInstance

  hereProxy: AxiosInstance

  identity: AxiosInstance
  identity2: AxiosInstance

  knowledge: AxiosInstance
  knowledge2: AxiosInstance

  messaging: AxiosInstance
  messaging2: AxiosInstance

  wsProxy: AxiosInstance
  notifications: AxiosInstance
  support: AxiosInstance

  nominatim: AxiosInstance

  updateConfig(config: Partial<Config>) {
    Object.assign(this.config, config)
  }

  getConfig() {
    return this.config
  }

  constructor(config: Config) {
    this.config = config

    const defaultInterceptor = (config: AxiosRequestConfig) => {
      const access_token = this.config.access_token()
      if(access_token) {
        config.headers['Authorization'] = `Bearer ${access_token}`
      }

      const lang = this.config.language()
      if(lang) {
        config.headers['Accept-Language'] = lang
      }

      return config
    }

    const commonConfig = {
      timeout: 30000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    }

    //--
    this.exchange = axios.create({
      paramsSerializer: (params: any) => qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
      baseURL: this.ownServerBaseUrl + '/exchange',
      ...commonConfig
    })
    this.exchange.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.fileServer = axios.create({
      baseURL: 'https://api.integration.roolz.fg13.net' + '/fileserver',
      ...commonConfig
    })
    this.fileServer.interceptors.request.use((config: AxiosRequestConfig) => ({
      ...config,
      headers: {
        ...config.headers,
        'X-Roolz-Auth': `Bearer ${this.config.access_token()}`,
        'Accept-Language': this.config.language()
      }
    }))
    //--


    //--
    this.hereProxy = axios.create({
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      baseURL: this.ownServerBaseUrl + '/here-proxy',
      ...commonConfig
    })
    this.hereProxy.interceptors.request.use((config: AxiosRequestConfig) => ({
      ...config,
      headers: {
        ...config.headers,
        'X-Roolz-Auth': `Bearer ${this.config.access_token()}`,
        'Accept-Language': this.config.language()
      }
    }))
    //--


    //--
    this.identity = axios.create({
      baseURL: this.ownServerBaseUrl + '/identity',
      ...commonConfig,
      headers: {
        ...commonConfig.headers,
        "Roolz-Product": "business",
      },
    })
    this.identity.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.identity2 = axios.create({
      baseURL: 'https://api.integration.roolz.fg13.net/identity',
      ...commonConfig,
      headers: {
        ...commonConfig.headers,
        "Roolz-Product": "business",
      },
    })
    this.identity2.interceptors.request.use(defaultInterceptor)


    //--
    this.knowledge = axios.create({
      baseURL: this.ownServerBaseUrl + '/knowledge',
      ...commonConfig,
    })
    this.knowledge.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.knowledge2 = axios.create({
      baseURL: 'https://api.integration.roolz.fg13.net/knowledge',
      ...commonConfig,
    })
    this.knowledge2.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.notifications = axios.create({
      baseURL: this.ownServerBaseUrl + '/notifications',
      paramsSerializer: (params: any) => qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
      ...commonConfig,
    })
    this.notifications.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.messaging = axios.create({
      baseURL: this.ownServerBaseUrl + '/messaging',
      ...commonConfig,
      headers: {
        ...commonConfig.headers,
        "Roolz-Product": "business"
      }
    })
    this.messaging.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.messaging2 = axios.create({
      baseURL: 'https://api.integration.roolz.fg13.net' + '/messaging',
      ...commonConfig,
      headers: {
        ...commonConfig.headers,
        "Roolz-Product": "business"
      }
    })
    this.messaging2.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.wsProxy = axios.create({
      baseURL: 'https://api.integration.roolz.fg13.net' + '/ws',
      ...commonConfig,
    })
    this.wsProxy.interceptors.request.use(config => ({
      ...config,
      headers: {
        ...config.headers,
        Authorization: `${this.config.access_token()}`,
      }
    }))
    //--


    //--
    this.support = axios.create({
      baseURL: this.ownServerBaseUrl + '/support',
      ...commonConfig,
      headers: {
        ...commonConfig.headers,
        "Roolz-Product": "business",
      },
    })
    this.support.interceptors.request.use(defaultInterceptor)
    //--


    //--
    this.nominatim = axios.create({
      baseURL: 'https://nominatim.openstreetmap.org',
      ...commonConfig,
    })
    this.nominatim.interceptors.request.use(config => ({
      ...config,
      headers: {
        ...config.headers,
        'Accept-Language': this.config.language() === 'ru'
          ? 'en'
          : this.config.language()
      }
    }))
    //--
  }
}
